import { CircularProgress } from '@mui/material';
import { BoxComponent } from '../../../base/box/Box';

const ImageLoader = ({ globalStyles }: any) => {
  return (
    <BoxComponent
      sx={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
      }}
    >
      <CircularProgress sx={{ color: globalStyles.heading.color }} size="8rem" />
      <p style={{ color: globalStyles.heading.color as string, fontSize: '24px' }}>Saving Changes....</p>
    </BoxComponent>
  );
};

export default ImageLoader;
